// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","paper":"paper-3kzFF","buttons":"buttons-CDo58","button":"button-2dhWw"};